<div class="body">
    <button class="button not-filled-button" (click)="goToPriceBoard()">
        <span>Ir al tablero</span>
    </button>
    
    <app-goals class="goals"></app-goals>
    <app-accumulated-tonnage></app-accumulated-tonnage>
    <app-order class="order-list"></app-order>
    <app-dolar class="dolar"></app-dolar>
</div>